import { render, staticRenderFns } from "./CardRevista.vue?vue&type=template&id=c8375fe8"
import script from "./CardRevista.vue?vue&type=script&lang=ts"
export * from "./CardRevista.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports